/**
 * Created by User on 29-Jul-17.
 */
import React, { Component } from 'react';

import Container from '../../components/Container';
import Heading from '../../components/Heading';

export default class Home extends Component {
    render() {
        return (
        <Container>
            <Heading title="Dashboard"></Heading>
            <div className="row">
                <div className="col-lg-12">
                    In future there will be charts!
                </div>
            </div>
        </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Home/index.js